import styled from "@emotion/styled";
import { T, display } from "./theme";

export const DialogBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  max-width: calc(100vw - 32px);
  background: ${T.surface};
  border: 1px solid ${T.line};
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 20px 60px rgba(27, 36, 48, 0.25);
`;

export const DialogTitle = styled.h2`
  font-family: ${display};
  font-size: 22px;
  line-height: 1.2;
  font-weight: 700;
  color: ${T.ink};
  margin: 0 0 20px;
`;
